import { Box, ChakraProvider, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";
import createCache from "@emotion/cache";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "../store";
import { CacheProvider } from "@emotion/react";
import { theme } from "../theme";
import { ThemedButton } from "../themed/ThemedButton";
import { ThemedHeading } from "../themed/ThemedHeading";
export const ConsentManagementBlock = (props) => {
    const openCM = () => {
        if (typeof window.Cookiebot === "object" && typeof window.Cookiebot.renew === "function") {
            window.Cookiebot.renew();
        }
    };
    const getIcon = () => {
        if (props.icon === "video") {
            return require('../../assets/film-light.svg');
        }
        return require('../../assets/map-light.svg');
    };
    return (React.createElement(Box, { bg: "reaGray.100", p: 12, display: "flex", flexDirection: "column", alignItems: "center", gap: 12 },
        React.createElement(Image, { src: getIcon(), width: "100px", height: "100%", objectFit: "contain" }),
        React.createElement(VStack, null,
            React.createElement(ThemedHeading, { textAlign: "center", as: "h2", fontSize: "2rem" }, props.title),
            React.createElement(Text, { textAlign: "center", maxW: "md" }, props.description)),
        React.createElement(ThemedButton, { onClick: () => openCM(), size: "lg" }, props.ctaLabel)));
};
class ConsentManagementBlockWeb extends HTMLElement {
    constructor() {
        var _a, _b, _c, _d;
        super();
        const title = (_a = this.getAttribute("title")) !== null && _a !== void 0 ? _a : "";
        const description = (_b = this.getAttribute("description")) !== null && _b !== void 0 ? _b : "";
        const ctaLabel = (_c = this.getAttribute("ctaLabel")) !== null && _c !== void 0 ? _c : "";
        const icon = (_d = this.getAttribute("icon")) !== null && _d !== void 0 ? _d : "";
        const shadowRoot = this.attachShadow({ mode: "open" });
        const root = document.createElement("duv");
        shadowRoot.appendChild(root);
        const cache = createCache({
            container: shadowRoot,
            key: "c"
        });
        const reactDom = createRoot(root);
        reactDom.render(React.createElement(Provider, { store: store },
            React.createElement(CacheProvider, { value: cache },
                React.createElement(ChakraProvider, { theme: theme },
                    React.createElement(ConsentManagementBlock, { title: title, description: description, ctaLabel: ctaLabel, icon: icon })))));
    }
}
if (!customElements.get('consent-management-block')) {
    customElements.define('consent-management-block', ConsentManagementBlockWeb);
}
